module.exports = __webpack_public_path__ + "static/ch5-scrub-bloody_sunday-02-48b021339ea48bb74fdfb6db34921d91.mp4";